import { RootState as RS } from "../types";
import { GlobalFetchPartition, GlobalFetchSlice } from "./reducer";

export const getGlobalFetchSlice = (s: RS): GlobalFetchSlice => s.globalFetch;

export const getStatusForGlobalFetchPartition = (
  s: RS,
  partition: GlobalFetchPartition
) => getGlobalFetchSlice(s)[partition];
